export default __webpack_public_path__ + "static/card-example4-a8c2637a7f61b75fd7735b0cb2654285.png";